import { createField } from '@/components/forms/field.schema';
import { Archive, Building2, Hash, Star, Tag, Users } from 'lucide-react';
import { z } from 'zod';

export const projectFields = {
  recnum: createField(z.number(), {
    fieldType: 'text',
    label: 'Recnum',
    readOnly: true,
    icon: Hash,
  }),
  projectname: createField(z.string(), {
    fieldType: 'text',
    label: 'Project Name',
    fullWidth: true,
  }),
  klant_naam: createField(z.string(), {
    fieldType: 'text',
    label: 'Client Name',
    readOnly: true,
    icon: Building2,
  }),
  users: createField(z.array(z.number()), {
    fieldType: 'foreignKeyArray',
    entity: 'user',
    label: 'Following Users',
    readOnly: true,
    icon: Users,
  }),
  id: createField(z.string(), {
    fieldType: 'text',
    label: 'ID',
    readOnly: true,
    icon: Tag,
  }),
  archived: createField(z.boolean(), {
    fieldType: 'boolean',
    label: 'Archived',
    icon: Archive,
  }),

  // Virtual field for "following" filter based on current user
  following: createField(z.boolean(), {
    fieldType: 'boolean',
    label: 'Following',
    readOnly: true,
    icon: Star,
    getVirtualValue: (project: any, context?: { userId: number }) => {
      // This will be handled by the custom filter logic
      // since we need access to the current user context
      if (!context?.userId) {
        throw new Error('userId context required for project.following field');
      }
      return project.users?.includes(context?.userId) ?? false;
    },
    filterConfig: {
      operations: ['is'],
      keywords: ['following', 'followed'],
      filterable: true,
    },
  }),
};
